<app-header></app-header>
<app-sidebar></app-sidebar>
<div [dir]="direction">
  <router-outlet></router-outlet>
</div>
